<template>
  <transition name="fade">
    <v-banner
      v-if="isImpersonating"
      color="warning"
      class="impersonation-banner d-flex align-center"
      icon="mdi-alert"
      max-width="30vw"
      rounded
      dark
      elevation="4"
      single-line
    >
      <span class="text-body-1">
        You are currently viewing as: <strong>{{ userName }}</strong>
      </span>
      <template #actions>
        <v-btn
          text
          small
          title="Return to normal user"
          @click="exitImpersonation"
        >
          <v-icon> mdi-exit-to-app </v-icon>
        </v-btn>
      </template>
    </v-banner>
  </transition>
</template>

<script>
export default {
  name: "ImpersonationBanner",
  data() {
    return {
      isImpersonating: false,
      userName: null,
    };
  },
  computed: {
    originalUser() {
      return this.$store.getters["core/originalUser"];
    },
  },
  watch: {
    originalUser: {
      handler() {
        this.checkImpersonation();
      },
      immediate: true,
    },
  },
  methods: {
    checkImpersonation() {
      this.isImpersonating = !!this.$store.getters["core/originalUser"];
      this.userName = this.$store.getters["core/fullName"];
    },
    exitImpersonation() {
      this.$store.dispatch("clients/stopImpersonation").then(() => {
        this.isImpersonating = false;
        this.$router.push("/dashboard");
        window.location.reload();
      });
    },
  },
};
</script>

<style lang="sass">
.impersonation-banner
  position: fixed !important
  top: 20px
  z-index: 99999 !important
  align-self: center

.fade-enter-active,
.fade-leave-active
  transition: opacity .5s

.fade-enter,
.fade-leave-to
  opacity: 0
</style>
